import { useContext, useEffect, useReducer } from 'react';
import { useSearchParams } from 'react-router-dom';

import { fetchEVStatusFactory } from '../../actions/email-verification/EmailVerificationActions';
import FormSpinner from '../../components/FormSpinner';
import {
    API_STATUSES,
    EmailVerificationStatuses,
    SignUpModes,
} from '../../constants';
import EmailVerificationContext, {
    INITIAL_EMAIL_VERIFICATION_STATE,
} from '../../contexts/email-verification/EmailVerificationContext';
import useMode from '../../hooks/sign-up/useMode';
import EmailVerificationReducer from '../../reducers/email-verification/EmailVerificationReducer';
import CancelledView from './views/CancelledView';
import ExpiredView from './views/ExpiredView';
import NotFoundView from './views/NotFoundView';
import PendingView from './views/PendingView';
import SystemErrorView from './views/SystemErrorView';
import VerifiedView from './views/VerifiedView';

interface IProps {
    mode: SignUpModes;
}

export const getView = (
    evStatus: EmailVerificationStatuses
): React.ReactNode => {
    switch (evStatus) {
        case EmailVerificationStatuses.EV_CANCELLED:
        case EmailVerificationStatuses.CANCELLED:
            return <CancelledView />;
        case EmailVerificationStatuses.EV_EXPIRED:
        case EmailVerificationStatuses.EXPIRED:
            return <ExpiredView />;
        case EmailVerificationStatuses.EV_NOT_FOUND:
            return <NotFoundView />;
        case EmailVerificationStatuses.PENDING:
            return <PendingView />;
        case EmailVerificationStatuses.VERIFIED:
            return <VerifiedView />;
        case EmailVerificationStatuses.EV_SYSTEM_ERROR:
        default:
            return <SystemErrorView />;
    }
};

export const _EmailVerificationForm = ({ mode }: IProps) => {
    const { state, dispatch } = useContext(EmailVerificationContext);
    const searchParams = useSearchParams();

    const evStatus = state.get('evStatus');
    const evStatusAPISubmit = state.get('evStatusAPISubmit');

    const fetchEvStatus = fetchEVStatusFactory(dispatch);

    useMode(mode);
    useEffect(() => {
        const urlStatus = searchParams[0].get('status');
        fetchEvStatus(urlStatus);
    }, []);

    if (evStatusAPISubmit.status === API_STATUSES.IN_PROGRESS) {
        return <FormSpinner />;
    }

    return (
        <div className='eh-card-block eh-form-email-verification'>
            {getView(evStatus.status)}
        </div>
    );
};

const EmailVerificationForm = (props: IProps) => {
    const [state, dispatch] = useReducer(
        EmailVerificationReducer,
        INITIAL_EMAIL_VERIFICATION_STATE
    );

    return (
        <EmailVerificationContext.Provider value={{ state, dispatch }}>
            <_EmailVerificationForm {...props} />
        </EmailVerificationContext.Provider>
    );
};

export default EmailVerificationForm;
